import React, { useEffect, useState } from 'react';
import { authProvider } from '../../../services/Security';
import { Button, CircularProgress, LinearProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tab, Tabs } from '@material-ui/core';
import '../../../scss/UVP.scss';
import { UVPAutoPay } from './UVPAutoPay';
import { UVPAutoPaymentBatch } from './UVPAutoPaymentBatch';
import { UVPAutoPayments } from './UVPAutoPayments';
import { ModuleConfigsVService } from '../../../services/V2/padre';
import { handleErrorToast } from '../../shared/Functions';
import { HttpTransportType, HubConnectionBuilder } from '@microsoft/signalr';
import InfoIcon from '@material-ui/icons/Info';

export const UVPAutoPayTabs = ({errorToast, successToast}) => {
    const [districtId, setDistrictId] = useState<any>();
    const [selectedPayment, setSelectedPayment] = useState<any>();
    const [selectedTab, setSelectedTab] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const [districtModules, setDistrictModules] = useState<any>();
    const [connection, setConnection] = useState<any>(null);
    const [batchId, setBatchId] = useState<any>(null);
    const [hasBeenCanceled, setHasBeenCanceled] = useState<boolean>(false);
    const [hasBeenCanceledByUser, setHasBeenCanceledByUser] = useState<string | null>(null);
    const [refresh, setRefresh] = useState<boolean>(true);
    const [progressLoading, setProgressLoading] = useState<boolean>(false);
    const [progress, setProgress] = useState<number>(0);

    window.addEventListener('message', event => {
        // IMPORTANT: check the origin of the data!
        if(!event.data) return;
        var data = JSON.parse(event?.data);
        authProvider.setToken(data?.token)
        setDistrictId(data?.districtId)
        // if (event.origin === 'https://your-first-site.example') {
        //     // The data was sent from your site.
        //     // Data sent with postMessage is stored in event.data:
        // } else {
        //     // The data was NOT sent from your site!
        //     // Be careful! Do not use it. This else branch is
        //     // here just for clarity, you usually shouldn't need it.
        //     return;
        // }
    });
    
    useEffect(() => {
        const newConnection = new HubConnectionBuilder()
            .withUrl(`${process.env.REACT_APP_CHARON_HOST}/hub/RecurringPayments`, {
                skipNegotiation: true,
                transport: HttpTransportType.WebSockets
                })
            .withAutomaticReconnect()
            .build();

        setConnection(newConnection);
    }, []);

    useEffect(() => {
        if (!districtId) return;
        setLoading(true)
        ModuleConfigsVService.moduleConfigsVGetDistrictModuleConfig(districtId)
		.then((x: any) => {
			setDistrictModules(x);
            setLoading(false)
		})
		.catch(x => errorToast(handleErrorToast(x)))
	}, 	[districtId]); // eslint-disable-line react-hooks/exhaustive-deps
    
    useEffect(() => {
        if (connection && districtId) {
            connection.start()
                .then(result => {
                    connection.on('RecurringMessage', message => {
                        var data = message
                        var username = authProvider.getUser().Username
                        if(data.districtId !== districtId) return;
                        if(!data) errorToast("Something Failed")
                        else if (data.percentage) {
                            setProgressLoading(true)
                            setProgress(data.percentage)
                            return;
                        } else if(!data.id) {
                            errorToast(data.message)
                            setLoading(false)
                        } else if(data.canceled) {
                            setBatchId(data.id)
                            if(data.modifiedByUser.toLowerCase().includes("rocketpack")) {
                                setHasBeenCanceled(true)
                            } else if(!data.modifiedByUser.toLowerCase().includes(username.toLowerCase())) {
                                setHasBeenCanceledByUser(data.modifiedByUser)
                            }
                        } else if (!data.ModifiedBy) {
                            setLoading(false)
                            setSelectedPayment(data.id)
                        }
                        setProgressLoading(false)
                        setProgress(0)
                        setRefresh(true)
                    });
                })
                .catch(e => console.log('Connection failed: ', e));
        }
    }, [connection, districtId]);// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = (e, tab) => {
        setSelectedTab(tab)
    }

    return (
        <React.Fragment>
            {hasBeenCanceledByUser !== null &&
                <Dialog
                    open={true}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title" style={{textAlign:"left"}}>Note</DialogTitle>
                    <DialogContent style={{textAlign:"left"}}>
                        <Grid container>
                            <Grid xs={1}>
                                <div style={{marginTop: "8px"}}>
                                    <InfoIcon color='primary' />
                                </div>
                            </Grid>
                            <Grid xs={9}>
                                <div><b>Recurring Payment Batch Canceled</b></div>
                                <div>Batch {batchId} has been canceled by another user.</div>
                                <br />
                                <div>Please create a new batch for review and submit for processing.</div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setHasBeenCanceledByUser(null)}
                            color="primary"
                            variant='contained'
                            style={{margin: "auto", color: "white"}}
                        >
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            }
            {hasBeenCanceled &&
                <Dialog
                    open={true}
                    aria-labelledby="form-dialog-title"
                >
                    <DialogTitle id="form-dialog-title" style={{textAlign:"left"}}>Note</DialogTitle>
                    <DialogContent style={{textAlign:"left"}}>
                        <Grid container>
                            <Grid xs={1}>
                                <div style={{marginTop: "8px"}}>
                                    <InfoIcon color='primary' />
                                </div>
                            </Grid>
                            <Grid xs={9}>
                                <div><b>Recurring Payment Batch Expired</b></div>
                                <div>Batch {batchId} has expired due to inactivity.</div>
                                <br />
                                <div>Please create a new batch for review and submit for processing.</div>
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={() => setHasBeenCanceled(false)}
                            color="primary"
                            variant='contained'
                            style={{margin: "auto", color: "white"}}
                        >
                            Ok
                        </Button>
                    </DialogActions>
                </Dialog>
            }
            {districtId && districtModules && !districtModules.ePayments ?
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "590px", width: "1600px" }}>
                    Electronic payments have been disabled and are not allowed.
                    <br />
                    You may now close this window.
                </div>
            :
            <Grid style={{backgroundColor: "white"}}>
                <Tabs className='uvp-tab-bar' style={{backgroundColor:"#f5f5f5", marginBottom: "20px"}} value={selectedTab} onChange={handleChange} TabIndicatorProps={{ style: { backgroundColor: "#3F8A3D", height: "4px" } }}>
                    <Tab className='uvp-tabs' label="Batch Summary" style={{backgroundColor: selectedTab === 0 ? "white" : "#E0E0E0"}}></Tab>
                    <Tab className='uvp-tabs' label="Batch Detail" disabled={!selectedPayment} style={{backgroundColor: selectedTab === 1 ? "white" : "#E0E0E0"}}></Tab>
                </Tabs>
                {selectedTab === 0 ?
                    <UVPAutoPay
                        errorToast={errorToast}
                        successToast={successToast}
                        setSelectedPayment={data => {
                            setSelectedPayment(data);
                            setSelectedTab(1)
                        }}
                        districtId={districtId}
                        refresh={refresh}
                        setRefresh={setRefresh}
                        setLoading={setLoading}
                        setRunningBatch={setProgressLoading} /> :
                    selectedPayment.hasBeenRun ?
                        <UVPAutoPayments
                            errorToast={errorToast}
                            successToast={successToast}
                            selectedPayment={selectedPayment}
                            setLoading={setLoading} /> :
                        <UVPAutoPaymentBatch
                            errorToast={errorToast}
                            successToast={successToast}
                            selectedPayment={selectedPayment}
                            setSelectedTab={setSelectedTab}
                            setHasBeenCanceled={setHasBeenCanceled}
                            setHasBeenCanceledByUser={setHasBeenCanceledByUser}
                            refresh={refresh}
                            setRefresh={setRefresh}
                            setLoading={setLoading}
                            setRunningBatch={setProgressLoading} />
                }
                {loading && 
                    <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
                }
                {progressLoading &&
                    <div className='loading-container'><div style={{margin:"auto", marginTop:"35px", width:"75%"}}><LinearProgress variant="determinate" value={progress} /></div></div>
                }
            </Grid>
            }
        </React.Fragment>
    );
}
